//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTrueFalse } from '../../components/helpers.js'
import { createFieldConfig, Store } from '../../components/QSelectUtils'
import { getChangedProperties } from '../../components/BusinessProcess/bussinessProcessObjectChanges.js'
import { getMainSurplusState } from './stockInventoryTools.js'

import BusinessProcessEventsHistoryDispatcher from '../../components/BusinessProcess/BusinessProcessEvents/BusinessProcessEventsHistoryDispatcher.vue'
import BusinessProcessCurrentEventMobile from '../../components/BusinessProcess/BusinessProcessEvents/BusinessProcessCurrentEventMobile.vue'
import StockInventoryToolsDispatcher from './StockInventoryToolsDispatcher.vue'
import StockInventoryRegradingRecordsInField from './StockInventoryRegradingRecordsInField.vue'
import StockInventoryRegradingRecordsMobile from './StockInventoryRegradingRecordsMobile.vue'
import StockInventoryToolsMobile from './StockInventoryToolsMobile.vue'
import StockInventorySurplusMobile from './StockInventorySurplusMobile.vue'
import StockInventorySurplusDispatcher from './StockInventorySurplusDispatcher.vue'
import StockInventoryExternalSynchronization from './StockInventoryExternalSynchronization.vue'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'
import DateTimeField from '../../components/Field/DateTimeField.vue'
import CardSeparator from '../../components/Card/CardSeparator.vue'
import Comments from '../../components/Comments/Comments.vue'

export default {
  components: {
    BusinessProcessEventsHistoryDispatcher,
    BusinessProcessCurrentEventMobile,
    StockInventoryToolsDispatcher,
    ItemsSearchField,
    DateTimeField,
    StockInventoryRegradingRecordsInField,
    StockInventoryExternalSynchronization,
    CardSeparator,
    Comments,
    StockInventorySurplusDispatcher
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    bussinessProcessConfiguration: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      formatTrueFalse: formatTrueFalse,

      stockFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 0,
        cached: false,
        proxy: {
          urlBase: '/service/delta/stockInventory/task/propertyValues',
          searchParamKey: 'searchPattern',
          // filterType: 'stock',
          // formId: 'stockInventoryTask',
          get urlParams () {
            const params = {}
            params.property = 'stock'
            // params.property = propertyKey
            // if (props) {
            //   params.properties = JSON.stringify(props)
            // }
            return params
          }
        }
      })),

      inventoryCompletenessFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        cached: true,
        proxy: {
          urlBase: '/service/delta/stockInventory/task/propertyValues',
          get urlParams () {
            const params = {}
            params.property = 'inventoryCompleteness'
            return params
          }
        }
      })),

      executorFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: true,
        searchValueMinLength: 0,
        searchFiltrationBySource: true,
        cached: false,
        proxy: {
          urlBase: '/service/delta/stockInventory/task/propertyValues',
          searchParamKey: 'searchPattern',
          get urlParams () {
            const params = {}
            params.property = 'executor'
            return params
          },
          filterType: 'stockInventoryExecutor',
          formId: 'stockInventoryTask'
        }
      })),
      executorFieldColumns: [
        {
          name: 'name',
          label: 'ФИО',
          align: 'left',
          field: row => row.name,
          sortable: true,
          columnFormat: 'object',
          columnObjectType: 'employee'
        },
        {
          name: 'position',
          label: 'Должность',
          align: 'left',
          field: 'position',
          sortable: false
        },
        {
          name: 'department',
          label: 'Отдел',
          align: 'left',
          field: 'department',
          sortable: false
        },
        {
          name: 'workAreas',
          label: 'Направление работ',
          align: 'left',
          field: 'workAreas',
          format: workAreas => workAreas != null ? workAreas.join(', ') : '',
          sortable: false
        }
      ]
    }
  },
  computed: {
    completed: function () {
      return !this.activeToolRecords.some(r => r.amountReal == null)
    },
    partialNotCompleted: function () {
      return this.request.partialExecutionAllowed && this.activeToolRecords.some(r => r.amountReal == null)
    },
    notCompleted: function () {
      return !this.request.partialExecutionAllowed && this.activeToolRecords.some(r => r.amountReal == null)
    },
    stateInfo: function () {
      return this.record.bp && this.record.bp.stateInfo
    },
    request: function () {
      return this.record.request
    },
    events: function () {
      return this.record.bp.events
    },
    requestProperties: function () {
      return this.record.requestProperties
    },
    toolRecords: function () {
      return this.request.toolRecords
    },
    toolRecordsPropertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    activeToolRecords: function () {
      return this.toolRecords.filter(r => !r.removed && !r.withdrawTime) || []
    },
    withdrawnToolRecordsPresent: function () {
      return this.toolRecords.some(r => !r.removed && r.withdrawTime != null)
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    accessEditTool: function () {
      return this.requestProperties.toolRecords.accessProps && this.requestProperties.toolRecords.accessProps.resultEditable
    },
    prolongationInterval: {
      get: function () {
        return this.request.prolongationInterval != null ? this.request.prolongationInterval / (1000 * 60 * 60) : null
      },
      set: function (value) {
        this.request.prolongationInterval = null

        if (value != null) {
          this.request.prolongationInterval = value * 1000 * 60 * 60
        }
      }
    },
    prolongationIntervalActual: {
      get: function () {
        return this.request.prolongationIntervalActual != null ? this.request.prolongationIntervalActual / (1000 * 60 * 60) : null
      },
      set: function (value) {
        this.request.prolongationIntervalActual = null

        if (value != null) {
          this.request.prolongationIntervalActual = value * 1000 * 60 * 60
        }
      }
    },
    filteredRegradingRecords: function () {
      const filteredRegradingRecords = this.request.regradingRecords && this.request.regradingRecords.filter(r => !r.removed) || []
      return filteredRegradingRecords
    },
    surplusRecords: function () {
      const filteredSurplusRecords = this.activeToolRecords && this.activeToolRecords.filter(r => r.amountDiffType && r.amountDiffType.id === 'surplus') || []
      return filteredSurplusRecords
    },
    mainSurplusState: function () {
      return getMainSurplusState(this.activeToolRecords, this.toolRecordsPropertyConfig)
    },
    displaySurplus: function () {
      return this.record.bp.stateInfo.id !== 'SIR00' && this.record.bp.stateInfo.id !== 'SIR01' && this.record.bp.stateInfo.id !== 'SIR02' && this.record.bp.stateInfo.id !== 'SIR03' && this.record.bp.stateInfo.id !== 'SIR04'
    }
  },
  methods: {
    onOpenCard: function (event, object, type, subtypeKey) {
      if (object.id && type) {
        this.$d_showObjectCard(object.id, type, event.ctrlKey, false, subtypeKey)
      }
    },
    validate: function (validFieldKeys) {
      if (this.$refs.toolRecords) {
        this.$refs.toolRecords.validate()
      }
      this.validateFields(validFieldKeys)
    },
    validateFields: function (validFieldKeys) {
      let validateResult = true
      validFieldKeys.forEach(validFieldKey => {
        if (this.$refs[validFieldKey]) {
          validateResult = this.$refs[validFieldKey].validate() && validateResult
        }
      })
      return validateResult
    },
    onSelectStock: function () {
      this.toolRecords.forEach(toolRecord => {
        this.$set(toolRecord, 'removed', true)
      })
      this.updateByChanges()
    },
    onSelectInventoryCompleteness: function () {
      this.toolRecords.forEach(toolRecord => {
        this.$set(toolRecord, 'removed', true)
      })
      this.updateByChanges()
    },
    onSelectExecutor: function () {
      this.updateByChanges()
    },
    updateByChanges: function () {
      const record = this.record

      this.$emit('update-by-changes', {
        request: getChangedProperties(record.request, record.requestInitial, record.requestProperties)
      })
    },
    onUpdate: function () {
      this.$emit('update')
    },
    openToolRecordsMobile: function () {
      const dialog = this.$d.dialog(this)
      const self = this
      dialog.show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryToolsMobile,
        contentProps: {
          record: this.record,
          readonly: !this.accessEditTool
        },
        componentHandlers: {
          close: function () {
            self.$emit('update')
            dialog.hide()
          },
          save: function () {
            self.$emit('save')
            dialog.hide()
          }
        }
      })
    },
    openRegradingRecordsMobile: function () {
      const dialog = this.$d.dialog(this)
      const self = this
      dialog.show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventoryRegradingRecordsMobile,
        contentProps: {
          record: this.record,
          readonly: !this.accessEditTool
        },
        componentHandlers: {
          close: function () {
            self.$emit('update')
            dialog.hide()
          },
          save: function () {
            self.$emit('save')
            dialog.hide()
          }
        }
      })
    },
    openSurplusMobile: function () {
      const dialog = this.$d.dialog(this)
      const self = this
      dialog.show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: StockInventorySurplusMobile,
        contentProps: {
          record: this.record,
          readonly: !this.accessEditTool
        },
        componentHandlers: {
          close: function () {
            self.$emit('update')
            dialog.hide()
          },
          save: function () {
            self.$emit('save')
            dialog.hide()
          }
        }
      })
    }
  }
}

